<template>
  <div style="width: 100%; position: relative">
    <div style="min-width: 100%; max-height: 100%">
      <el-carousel
        ref="carousel"
        :interval="cutTime"
        :autoplay="autoplay"
        @change="carouselChange($event)"
        :width="imgWidth + 'px'"
        :height="imgHeight + 'px'"
      >
        <el-carousel-item
          v-for="(item, index) in rotationPlotList"
          :key="index"
          style="width: 100%"
        >
          <video
            v-if="item.mp4"
            :ref="'videoPlayer' + index"
            :playsinline="true"
            autoplay
            muted
            :width="'100%'"
            :height="'100%'"
          >
            <source :src="item.mp4" type="video/mp4" />
          </video>
          <el-image
            v-if="item.picture"
            :src="item.picture"
            style="height: 100%; width: 100%"
          />
          <!--        2复杂4高速>1高精度3集多-->
          <!-- (index === 0 ? 'position:absolute;color: #ffffff;bottom:10%;left: 50%; transform: translatex( -50%)' : '') -->
          <div
            class="title"
            style="color: #e6e6e6; font-size: 1.2em"
            :style="
              (index === 1
                ? 'position:absolute;bottom:7%;left: 50%; transform: translatex( -50%)'
                : '') +
              (index === 0
                ? 'position:absolute;color:#000000;top:5%;left: 50%; transform: translatex( -50%)'
                : '') +
              (index === 2
                ? 'position:absolute; color: #ffffff;top:3%;left: 50%; transform: translatex( -50%)'
                : '') +
              (index === 3
                ? 'position:absolute;color:#000000;top:5%;left: 50%; transform: translatex( -50%)'
                : '')
            "
          >
            <h1 style="margin-bottom: 10px">{{ item.title }}</h1>
            <h1 v-if="item.title2" style="margin-top: 0">{{ item.title2 }}</h1>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
export default {
  name: "RotationPlotComponent",
  data() {
    return {
      rotationPlotList: global.rotationPlotList,
      imgHeight: 525,
      imgWidth: 0,
      pageWidth: 0,
      cutTime: 3000,
      // 切换时间
      autoplay: false,
      // 当前的index值
      nowIndex: 0,
    };
  },
  created() {
    // 监听窗口大小变化事件
    window.addEventListener("resize", this.handleResize);
    this.imgWidth = window.innerWidth;
    this.handleResize();
  },
  destroyed() {
    // 移除窗口大小变化事件监听器
    window.removeEventListener("resize", this.handleResize);
  },
  mounted() {
    this.imgWidth = window.innerWidth;
    this.listenVideo();
    // let _this = this
    // setTimeout(function () {
    //   console.log('触发了')
    //   _this.$refs.carousel.next()
    // }, 5000)
  },
  watch: {
    nowIndex(newIndex, oldIndex) {
      if (newIndex === 3 || newIndex === 0) {
        this.listenVideo();
        // setTimeout(function () {
        //   this.$refs.carousel.next()
        // }, 5000)
      }
    },
  },
  methods: {
    // 窗口大小变化时更新页面宽度值
    handleResize() {
      this.imgHeight = window.innerWidth / 3;
      this.imgWidth = window.innerWidth;
    },
    carouselChange(index) {
      this.nowIndex = index;
      if (index === 0 || index === 3) {
        this.autoplay = false;
        const video = this.$refs["videoPlayer" + index];
        video[0].load();
      } else {
        this.autoplay = true;
      }
    },
    listenVideo() {
      // 绑定视频
      let videoElement = this.$refs["videoPlayer" + this.nowIndex];
      let _this = this;
      if (videoElement) {
        // 监听视频播放结束事件
        videoElement[0].addEventListener("play", function () {
          _this.autoplay = false;
        });
        videoElement[0].addEventListener("ended", function () {
          // 在视频播放结束后执行一些操作
          _this.$refs.carousel.next();
          _this.autoplay = true;
          // 走马灯换页
        });
      } else {
        console.log("视频获取失败");
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/rotationPlotComponent/rotationPlotComponent.vue